<div class="visible-xx" visible-size="xx" #responsiveXX></div>
<div class="visible-xs" visible-size="xs" #responsiveXS></div>
<div class="visible-sm" visible-size="sm" #responsiveSM></div>
<div class="visible-md" visible-size="md" #responsiveMD></div>
<div class="visible-lg" visible-size="lg" #responsiveLG></div>
<div class="visible-xl" visible-size="xl" #responsiveXL></div>
<div class="visible-xxl" visible-size="xxl" #responsiveXXL></div>
